import { action, computed, makeObservable, observable } from 'mobx';

import Auth from './AuthManager';

const CONTEXT_HELP_ENDPOINTS = {
  FETCH_CONTEXT_HELP: '/api/viewContextHelp'
};

export class ContextHelpManager {
  constructor() {
    makeObservable(this);
  }

  @observable testBuilderContextHelpId = 'TEST_BUILDER_ZERO_STATE';

  @observable contextHelpMap = new Map();

  @action clearAll = () => {
    this.clearContextHelpMap();
  }

  @action fetchContextHelp = async (contextHelpId) => {
    try {
      const { FETCH_CONTEXT_HELP } = CONTEXT_HELP_ENDPOINTS;
      const response = await Auth.fetch(`${Auth.ecms}${FETCH_CONTEXT_HELP}?id=${contextHelpId}`, {
        method: 'GET'
      });
      if (response.status === 'SUCCESS' && response.data?.[0]) {
        this.contextHelpMap.set(contextHelpId, response.data[0]?.body);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  @action clearContextHelpMap = () => {
    this.contextHelpMap = new Map();
  }

  @action setTestBuilderContextHelpId = (testBuilderContextHelpId) => {
    this.testBuilderContextHelpId = testBuilderContextHelpId;
  }

  @computed get testBuilderContextHelpData() {
    return this?.contextHelpMap?.get?.(this.testBuilderContextHelpId);
  }
}

export default new ContextHelpManager();
